import { CoreModal, CoreSpinner } from "@verity/components/core";
import i18n from "../../../../i18n";

export type DownloadRequestStatusType =
	| "unsent"
	| "sending"
	| { status: "sent"; ready: boolean; emailDestination: string }
	| "failed";

const DownloadRequestModal = ({ status, onClose }: { status: DownloadRequestStatusType; onClose: () => void }) => {
	let title = i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.requestDownload");
	let text = "";
	const loading = status === "sending";
	if (typeof status === "object" && status.status === "sent") {
		title = i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.downloadRequestSend");
		text = i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.downloadRequestSendText", {
			emailDestination: status.emailDestination,
		});
	} else if (status === "failed") {
		title = i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.downloadRequestNotSend");
		text = i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.downloadRequestNotSendText");
	}

	return (
		<CoreModal
			open={status !== "unsent"}
			title={title}
			minWidth="40%"
			minHeight="30%"
			widthFixed
			onClose={
				loading
					? () => {
							return;
						}
					: onClose
			}
			buttons={[
				{
					text: i18n.t("result.components.studentSelection.videoPlayer.videoPlayerTSX.close"),
					color: "secondary",
					onClick: onClose,
					disabled: loading,
				},
			]}
			disableTopCloseButton={loading}
		>
			{loading ? (
				<div style={{ display: "flex", placeContent: "center" }}>
					{" "}
					<CoreSpinner size={64} />{" "}
				</div>
			) : (
				<div>{text}</div>
			)}
		</CoreModal>
	);
};

export default DownloadRequestModal;
